import React from 'react';
import { Link } from 'react-router-dom';
// a link which acts like a button
const LinkButton = (props) => {
    const { children, onClick, ...linkProps } = props;
    return (React.createElement(Link, { ...linkProps, role: "button", tabIndex: 0, onKeyDown: (event) => {
            if (event.key === 'Enter' && event.currentTarget === event.target) {
                onClick();
            }
        }, onClick: onClick }, children));
};
export default LinkButton;
